import React, { useEffect, useState } from "react";
import PaperDisplay from "./PaperDisplay";
import Loader from "react-loader-spinner";
import DeathFilter from "./DeathFilter";
import Countries from "../Countries";
import DateDropdown from "./DateDropdown";
import { useSelector, useDispatch } from "react-redux";
import * as allActions from "../store/actions/papers";
import "./PaperDisplay.css";

const Papers = () => {
  const [filterLoading, setFilterLoading] = useState(true);
  const error = useSelector((state) => state.papers.error);
  const country = useSelector((state) => state.papers.country);
  const days = useSelector((state) => state.papers.days);
  const filter = useSelector((state) => state.papers.filter);
  const filterList = useSelector((state) => state.papers.filterList);
  const paperList = useSelector((state) => state.papers.paperList);
  let loading = useSelector((state) => state.papers.loading);

  const dispatch = useDispatch();

  const handleDays = (newDays) => {
    dispatch(allActions.selectDays(newDays));
  };

  const handleCountry = (newCountry) => {
    if (!newCountry) {
      alert("Must select a country...");
      return;
    } else {
      dispatch(allActions.selectCountry(newCountry));
    }
  };

  const handleFilter = (evt) => {
    if (evt.target.value === "all") {
      dispatch(allActions.resetFilter());
    } else {
      dispatch(allActions.setFilter(evt.target.value));
    }
  };

  useEffect(() => {
    setFilterLoading(true);
    if (error) {
      alert(
        "Sorry - there was an error on the Pubmed server. This could be due to too many papers being requested which is usually corrected by using a shorter timeframe for your search. Otherwise, try different search parameters or refresh your browser - if the problem persists you might have to try again later."
      );
      dispatch(allActions.resetError());
      setFilterLoading(false);
    } else {
      if (!filter) {
        dispatch(allActions.getPapers(days, country)).then(() => setFilterLoading(false)
        );
      } else if (filter) {
        dispatch(allActions.filterPapers(filter, days, country)).then(() => setFilterLoading(false)
        );
      }
    }
  }, [error, country, days, filter, dispatch]);

  let listDisplay = "";
  if (loading || filterLoading) {
    listDisplay = (
      <Loader
        type="ThreeDots"
        color="rgb(245,153,47"
        height={80}
        width={80}
        className="loader"
      />
    );
  } else {
    listDisplay = <PaperDisplay paperlist={!filter ? paperList : filterList} />;
  }

  return (
    <div>
      <div className="filterContainer">
        <h3 className="filterLabel">Filter papers by:</h3>
        <DateDropdown
          days={days}
          dayHandler={handleDays}
          className="filterItem"
        />
        <DeathFilter onChangeHandler={handleFilter} className="filterItem" />
        <Countries
          country={country}
          countryHandler={handleCountry}
          className="filterItem"
        />
      </div>
      {loading ? (
        <h2 className="fetchingText">Fetching Papers...</h2>
      ) : !filter ? (
        <h2 className="displayModeHeading">{`All cell death papers with authors from ${country} in the last ${days} days`}</h2>
      ) : (
        <h2 className="displayModeHeading">
          {`All papers with authors from ${country} in the last ${days} days filtered by: ${filter.replace(
            "_",
            " "
          )}`}
        </h2>
      )}
      {listDisplay}
    </div>
  );
};

export default Papers;
